import { ConfigService } from './../config/config.service';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { API_ENDPOINT } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private httpClient: HttpClient,
    private config: ConfigService
  ) { }

  async getCustomer(id: any) {
    //const config = await this.config.getConfig();
    const params = `id=${id}&version=${API_ENDPOINT.version}`;
    const url = `${API_ENDPOINT.endpoint}/customer?${params}`;

    try {
      return await this.httpClient.get(url).toPromise();
    } catch (error:any) {
      return { status: false, code: error.error.status, message: error.error.title };
    }
  }

}
